import React from 'react';
import {Flex, Title} from '@priority-software/priority-style-react';
import texts from '../texts';

export const ModalTitle = ({step}: {step: number}) => {
    return step === 2 ? (
        <Title skin="h3" text={texts.secondMessageTitle} />
    ) : (
        <Flex justifyContent="flex-start">
            <Title skin="h3" text={texts.firstMessageTitle} />
            &nbsp;
            <Title skin="h3" fontWeight="bold" text="Priority" />
        </Flex>
    );
};
